const taInfo = [
  {
    name: 'Jasmin Mousavi',
    email: 'mousavij@oregonstate.edu',
    appointmentsLink: 'https://calendar.google.com/calendar/u/0/selfsched?sstoken=UUNvbXM2NHpwNkg5fGRlZmF1bHR8M2Y0YjhlNTRiOTE3ZTNiNzNhNzY0NzIyNDJiMjY0ZGI',
    videoConferenceLink: 'https://oregonstate.zoom.us/j/94053640120?pwd=M1hXUUZUSnE1MGlYNHltMWJBcHVaUT09',
    officeHours: [
      {
        day: 'Wed',
        time: '1:00 &ndash; 2:00pm',
        location: 'KEC Atrium'
      },
      {
        day: 'Fri.',
        time: '10:00am &ndash; 12:00pm',
        location: 'Zoom',
        videoConferenceLink: 'https://oregonstate.zoom.us/j/94053640120?pwd=M1hXUUZUSnE1MGlYNHltMWJBcHVaUT09',
        details: 'Use the camera icon next to these office hours to connect to the Zoom meeting.'
      },
    ],
    gradingHours: [
      {
        day: 'Mon',
        time: '12:00 &ndash; 2:00pm',
        location: 'KEC Atrium'
      },
      {
        day: 'Tues.',
        time: '11:30am &ndash; 2:00pm',
        location: 'KEC Atrium'
      },
      {
        day: 'Thurs.',
        time: '11:30am &ndash; 2:00pm',
        location: 'KEC Atrium'
      },
    ]
  },
  {
    name: "Sumer Patel",
    email: "patelsum@oregonstate.edu",
    appointmentsLink: 'https://calendar.google.com/calendar/u/0/selfsched?sstoken=UUZROFBnTkR6Z090fGRlZmF1bHR8MmQ2N2IzMTNjYjEwZjE3M2VkOGE4NTgzOWY0NjgyZGU',
    videoConferenceLink: 'https://oregonstate.zoom.us/j/4637552622?pwd=V1lZMm1GRlpKMzlGREdFb2dsMkdYdz09',
    officeHours: [
      {
        day: 'Mon.',
        time: '10:00 &ndash; 11:30am',
        location: 'KEC Atrium'
      },
      {
        day: 'Wed.',
        time: '10:00 &ndash; 11:30am',
        location: 'Zoom',
        videoConferenceLink: 'https://oregonstate.zoom.us/j/4637552622?pwd=V1lZMm1GRlpKMzlGREdFb2dsMkdYdz09',
        details: 'Use the camera icon next to these grading hours to connect to the Zoom meeting.'
      },
    ],
    gradingHours: [
      {
        day: 'Tues.',
        time: '10:00am &ndash; 1:00pm',
        location: 'KEC Atrium'
      },
      {
        day: 'Thurs.',
        time: '12:00 &ndash; 4:00pm',
        location: 'KEC Atrium'
      }
    ]
  }
];

export default taInfo;
